import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppService } from "src/app/app.service";
import { AppState } from "src/app/store/state/app.state";
import { QcDashboardDataService } from "../qc-dashboard-data.service";
import * as GlobalSubheaderActions from "../../store/actions/global-subheader.actions";
@Component({
  selector: "app-qc-dashboard-page",
  templateUrl: "./qc-dashboard-page.component.html",
  styleUrls: ["./qc-dashboard-page.component.scss"],
  host: { class: "qc-dashboard-page-component" },
})
export class QcDashboardPageComponent implements OnInit {
  ticker: string;
  allTickers;
  notesData: any;
  constructor(
    private route: ActivatedRoute,
    private qcDashboardDataService: QcDashboardDataService,
    private router: Router,
    private appService: AppService,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((param) => {
      this.ticker = decodeURIComponent(param.ticker);
      this.qcDashboardDataService
        .getCompanies(this.ticker)
        .subscribe((data: any) => {
          this.allTickers = data.availableCompanies.sort(
            (companyA, companyB) => {
              if (companyA.name.toLowerCase() < companyB.name.toLowerCase()) {
                return -1;
              }
              if (companyA.name.toLowerCase() > companyB.name.toLowerCase()) {
                return 1;
              }
              return 0;
            },
          );
          this.ticker = data.currentCompany[0].shortname;
        });
      this.store.dispatch(new GlobalSubheaderActions.SubheaderChanged());
      this.store.dispatch(
        new GlobalSubheaderActions.TickerChanged(this.ticker),
      );
    });
  }
  setTicker(ticker) {
    const today = new Date();
    const currentTime = today.toUTCString();
    this.appService.logUserAction(
      {},
      this.ticker,
      "",
      "ANALYST_DASHBOARD",
      {
        UTCTIME: currentTime,
        VALUE: ticker,
      },
      "",
      "",
    );
    this.router.navigateByUrl(`company/${ticker}/analystdashboard`);
  }
  changeNotes(data) {
    this.notesData = data;
  }
}
